import React from 'react';
import { Button } from '@flixbus/honeycomb-react';
import { Icon, IconCheckmarkStrongSolid, IconDocument } from '@flixbus/honeycomb-icons-react';
import styles from './file-upload-button.module.scss';

type FileUploadButtonProps = {
  file: File | null;
  // eslint-disable-next-line no-unused-vars
  onFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onRemove: () => void;
  inputRef: React.RefObject<HTMLInputElement>;
};

const FileUploadButton: React.FC<FileUploadButtonProps> = ({
  file,
  onFileChange,
  onRemove,
  inputRef,
}) => {
  const handleButtonClick = () => {
    inputRef.current?.click();
  };

  return (
    <div>
      {!file ? (
        <>
          <input
            ref={inputRef}
            type='file'
            accept='.csv,text/csv'
            onChange={onFileChange}
            style={{ display: 'none' }}
          />
          <Button onClick={handleButtonClick}>
            <Icon size={4} InlineIcon={IconDocument} />
            Choose file
          </Button>
        </>
      ) : (
        <div className={styles.file}>
          <div className={styles.iconContainer}>
            <Icon size={6} InlineIcon={IconDocument} extraClasses={styles.icon} />
            <Icon
              size={3}
              InlineIcon={IconCheckmarkStrongSolid}
              extraClasses={styles.iconCheckmark}
            />
          </div>
          <div className={styles.fileName}>
            <span>{file.name}</span>
          </div>
          <Button onClick={onRemove}>Remove</Button>
        </div>
      )}
    </div>
  );
};

export default FileUploadButton;
